<template>
	<div class="home">
		<div class="banner">
			<div class="in">
				<div class="btn ios" @click="download('ios')">
					<img src="@/assets/images/apple.png" />
					<div class="text">
						<span class="t1">Download on the</span>
						<span class="t2">App Store</span>
					</div>
				</div>
				<div class="btn android" @click="download('android')">
					<img src="@/assets/images/android_g.png" />
					<div class="text">
						<span class="t1">Download it from</span>
						<span class="t2">Android Market</span>
					</div>
				</div>
			</div>
		</div>

		<div class="box-1">
			<div class="title-box">
				<img src="@/assets/images/title_1.png" />
			</div>
			
			<div class="card-box">
				<div class="card">
					<div class="info">
						<img class="icon" src="@/assets/images/home_icon_1.png"/>
						<div class="title">手机通讯</div>
						<div class="e">Mobile communication</div>
					</div>
				</div>
				<div class="card">
					<div class="info">
						<img class="icon" src="@/assets/images/home_icon_2.png"/>
						<div class="title">珠宝首饰</div>
						<div class="e">Jewelry</div>
					</div>
				</div>
				<div class="card">
					<div class="info">
						<img class="icon" src="@/assets/images/home_icon_3.png"/>
						<div class="title">美妆护肤</div>
						<div class="e">Beauty and skincare</div>
					</div>
				</div>
				<div class="card">
					<div class="info">
						<img class="icon" src="@/assets/images/home_icon_4.png"/>
						<div class="title">箱包</div>
						<div class="e">luggage and bags</div>
					</div>
				</div>
			</div>
		</div>

		<!-- <div class="news-box">
			<div class="title-box">
				<img src="@/assets/images/title_2.png"/>
			</div>
			
			<div class="tab">
				<div v-for="item in tabs" class="item" :class="{ 'active': tabActive === item.dictValue }"
					@click="changeType(item.dictValue)">
					<span>{{ item.dictLabel }}</span>
				</div>
			</div>
			
			<div class="list">
				<div class="item" v-for="(item, index) in news" @click="goDetail(item, index)">
					<img :src="item.pic" style="object-fit: cover;">
					<h3>{{ item.title }}</h3>
					<div class="info">
						<span class="time">{{ item.pushDate }}</span>
						<span class="form">{{ item.mediaChannel }}</span>
					</div>
					<div class="des">{{ item.excerpt }}</div>
				</div>
			</div>
					
			<div class="more" @click="goList()">MORE</div>
		</div> -->

		<div class="box-3">
			<div class="in">
				<div class="title">每一次消费都值得期待</div>
				<div class="sub">Authentic product guarantee</div>
				<div class="info">
					<p>
						为提升购物体验，鹿优选提供快速且高效的物流服务，确保货品安全、迅速地送达您手中。
					</p>
					<p style="margin-bottom: .24rem">
						我们的目标是通过高效的服务和质量保证，使每一次购物都成为一次愉快而满意的体验。
					</p>
					<p>
						选择鹿优选，享受便捷、智能的现代购物之旅，让每一次消费都值得期待。
					</p>
				</div>
			</div>
		</div>

		<div class="box-4">
			<div class="in">
				<div class="phone">
					<img src="@/assets/images/phone_home_v2.png" />
				</div>
				<div class="right">
					<div class="title">严选商品 正品保证</div>
					<p>
						我们的产品系列丰富多样，涵盖时尚、家居、科技等多个领域，与众多国际知名品牌紧密合作，确保每件商品都是正品。
					</p>
					<img src="@/assets/images/icons.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { queryListFromH5, getNewsTab } from '@/axios/api.js'
export default {
	data() {
		return {
			news:[],
			tabs:[],
			tabActive:'',
		};
	},
	created() {
		getNewsTab().then(res => {
			this.tabs = res.data.data
			this.tabActive = this.tabs[0].dictValue
			this.getNews()
		})
	},
	mounted() { },
	computed: {},
	methods: {
		goList() {
			this.$router.push("/news");
		},
		goDetail(item, index) {
			if (item.jumpType === "外部链接") {
				window.open(item.outLink);
			} else {
				this.$router.push(
					`/detail?id=${item.id}&tab=${this.tabActive}&nodeNum=${index + 1}`
				);
			}
		},
		getNews() {
			this.news = [];
			let params = {
				pageNum: 1,
				pageSize: 6,
				tab: this.tabActive,
				topUp: 1,
			};
			queryListFromH5(params).then((res) => {
				this.news = res.data.data.list;
			});
		},
		changeType(dictValue) {
			this.tabActive = dictValue;
			this.getNews();
		},
		change(index) {
			this.activeIndex = index;
		},
		
		download(type){
			if(type === 'android'){
				window.open('https://package.luyouxuan.com/package/LuYouXuan.apk')
			}else if(type === 'ios'){
				window.open('https://apps.apple.com/cn/app/id6636531470')
			}
		}
	},
};
</script>

<style scoped lang="less">
.title-box{
		margin-bottom: .6rem;
		img{
			display: block;
			margin: 0 auto;
			width: auto;
			height: .6rem;
		}
	}

.home {
	padding-top: .5rem;
}

.banner {
	height: 3rem;
	background: #ff4f6a url("../../assets/images/banner_home.png") no-repeat -0.3rem center;
	background-size: auto 100%;

	.in {
		display: flex;
		padding-top: 1.8rem;
		justify-content: center;
		.btn{
					height: .5rem;
					border-radius: .04rem;
					display: flex;
					align-items: center;
					padding: 0 .1rem;
					box-sizing: border-box;
					margin: 0 .1rem;
					img{
						width: .3rem;
						height: auto;
						margin-right: .1rem;
					}
					.text{
						display: flex;
						flex-direction: column;
						.t1{
							font-size: .12rem;
							line-height: 1;
						}
						.t2{
							font-size: .16rem;
							line-height: 1;
						}
					}
				}

		.ios {
			background: #fff;
		}

		.android {
			background: #fff;
		}
	}
}

.box-1 {
	padding: .5rem 0 .6rem 0;
	
	.card-box{
		width: 3.6rem;
		margin: 0 auto;
		display: flex;
		flex-wrap: wrap;
		.card{
			overflow: hidden;
			width: 1.8rem;
			height: 1.8rem;
			position: relative;
			&:nth-child(1){
				background: url("../../assets/images/home_pic_1.png") no-repeat center center;
				background-size: cover;
			}
			&:nth-child(2){
				background: url("../../assets/images/home_pic_2.png") no-repeat center center;
				background-size: cover;
			}
			&:nth-child(3){
				background: url("../../assets/images/home_pic_3.png") no-repeat center center;
				background-size: cover;
			}
			&:nth-child(4){
				background: url("../../assets/images/home_pic_4.png") no-repeat center center;
				background-size: cover;
			}
			
			.info{
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				z-index: 4;
				box-sizing: border-box;
				padding: .2rem 0 0 .2rem;
				.icon{
					width: .24rem;
					height: .24rem;
					margin-bottom: .1rem;
				}
				.title{
					color: #fff;
					font-size: .2rem;
				}
				.e{
					color: #fff;
					font-size: .14rem;
					margin-bottom: .6rem;
				}
				.add{
					width: .2rem;
					height: .2rem;
				}
			}
		}
	}
}

.news-box {
	padding: .6rem 0;
	background: #fff url("../../assets/images/news_bg.png") top center no-repeat;
	background-size: cover;

	.tab {
		margin: 0 auto .28rem 0;
		display: flex;
		align-items: center;
		justify-content: center;

		.item {
			margin-right: .1rem;
			margin-left: .1rem;
			border-radius: .40rem;
			display: flex;
			align-items: center;
			cursor: pointer;
			background: #fff;
			height: .40rem;
			padding: 0 .2rem;

			span {
				color: #ff4f6a;
				font-size: .14rem;
				font-weight: 500;
			}

			&.active {
				background: #ff4f6a;

				span {
					color: #fff;
				}
			}
		}
	}

	.list {
		padding: 0 .24rem;
		overflow-x: auto;
		white-space: nowrap;
		padding-bottom: .4rem;
		margin-bottom: .4rem;
	
		.item {
			display: inline-block;
			vertical-align: top;
			width: 3rem;
			height: 3.7rem;
			padding: .16rem;
			box-sizing: border-box;
			background: #fff;
			margin: 0 8px 40px 8px;
			cursor: pointer;
			white-space: normal;
	
			img {
				width: 100%;
				height: 1.48rem;
			}
	
			h3 {
				margin-bottom: .12rem;
				font-size: .18rem;
			}
	
			.info {
				margin-bottom: .12rem;
	
				span {
					font-size: .12rem;
	
					&.time {
						color: #AEB3C0;
						margin-right: .16rem
					}
				}
			}
	
			.des {
				color: #AEB3C0;
				font-size: .15rem;
			}
		}
	}

	.more {
		color: #aeb3c0;
		font-size: 18px;
		border-radius: 40px;
		border: #c3c3c3 1px solid;
		height: 40px;
		width: 180px;
		display: flex;
		margin: 0 auto;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		background: rgba(255, 255, 255, 0);
		transition: all 0.3;

		&:hover {
			background: rgba(255, 255, 255, 1);
		}
	}
}

.box-3 {
	background: url("../../assets/images/box_bg.png") no-repeat center center;
	background-size: cover;

	.in {
		padding: .4rem;
		box-sizing: border-box;
		color: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		height: 100%;
		background: linear-gradient(to bottom,
				#ff4f6a 0%,
				rgba(255, 79, 106, 0) 100%);
	}

	.title {
		font-size: .3rem;
		font-weight: bold;
		line-height: 1;
	}

	.sub {
		font-size: .14rem;
		font-weight: 400;
		text-transform: uppercase;
		margin-bottom: .6rem;
	}

	p {
		text-align: center;
		font-size: .14rem;
		font-weight: 400;
	}
}

.box-4 {
	background: url("../../assets/images/box_4_bg.png") repeat-x bottom left;
	background-size: auto 1rem;

	.in {
		padding: .4rem 0 0.5rem 0;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		align-items: center;
	}

	.phone {
		margin-bottom: .4rem;
		img {
			width: 3rem;
			height: auto;
			animation: floatAnimation 3s infinite;
		}
	}

	.right {
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		align-items: center;
		.title {
			color: #ff4f6a;
			font-size: .32rem;
			font-weight: bold;
			margin-bottom: .2rem;
		}

		p {
			padding: 0 0.4rem;
			font-size: .16rem;
			color: #545454;
			margin-bottom: .2rem;
		}

		img {
			width: 3.4rem;
			height: auto;
		}
	}
	
	@keyframes floatAnimation {
	  0% {
	    transform: translateY(0);
	  }
	  50% {
	    transform: translateY(30px);
	  }
	  100% {
	    transform: translateY(0);
	  }
	}
}
</style>
